import { FC, useContext } from "react";
import { filterDTO } from "../../types";
import { FilterContext } from "../FilterContext";
import { activeFiltersToString } from "../FilterFormFunctions";
import ActiveFilterItem from "./ActiveFilterItem";

const ActiveFilterList: FC<ActiveFilterListProps> = (props) => {
    const currentContext = useContext(FilterContext)

    return (
        <>
            {props.filters &&
                props.filters.map((filter: filterDTO, index) => (
                    filter.userValues && 
                        <ActiveFilterItem
                            key={filter.columnName}
                            labelTitle={filter.displayName}
                            labelContent={activeFiltersToString(filter.typeUI, filter.userValues, filter.filterSelectValues)}
                            onClick={() => {currentContext.clearFilter(filter)}}
                        />
                ))
            }
        </>
    )
}

export default ActiveFilterList

interface ActiveFilterListProps {
    filters: filterDTO[];
}